/* ==========================================================================
   Acordeón FAQ — abre y cierra una pregunta a la vez.
   Se carga tanto en la página Contact como en la página FAQ propia.
   ========================================================================== */

(function () {
  'use strict';

  function boot() {
    var toggles = document.querySelectorAll('[data-faq-toggle]');

    for (var i = 0; i < toggles.length; i++) {
      (function (btn) {
        if (btn.dataset.gyaaReady === '1') return;
        btn.dataset.gyaaReady = '1';

        btn.addEventListener('click', function () {
          var row = btn.closest('.gyaa-faq__row');
          var panel = row ? row.querySelector('[data-faq-panel]') : null;
          var open = btn.getAttribute('aria-expanded') === 'true';

          // Cierra las demás: en el Figma solo hay una abierta
          var all = document.querySelectorAll('[data-faq-toggle]');
          for (var k = 0; k < all.length; k++) {
            if (all[k] === btn) continue;
            all[k].setAttribute('aria-expanded', 'false');
            var otherRow = all[k].closest('.gyaa-faq__row');
            var otherPanel = otherRow ? otherRow.querySelector('[data-faq-panel]') : null;
            if (otherPanel) otherPanel.hidden = true;
          }

          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.hidden = open;
        });
      })(toggles[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
